import {
  TableCellType,
  TableHeader,
} from "../../../../../components/custom-table/table";
import {
  EditableTagListCellValue,
  EditableTextWithIconCellValue,
} from "../../../../../components/custom-table/tableCell/cellTypes";
import { BucketRow } from "../data-model/bucketModel";

export const BUCKET_FIELD_KEYS = {
  name: "name",
  sub_bucket: "sub_bucket",
  keywords: "keywords",
} as const;

export const buildBucketTableHeaders = (): TableHeader[] => [
  {
    key: BUCKET_FIELD_KEYS.name,
    label: "Bucket",
    order: 0,
    width: 18,
    sortable: true,
    type: TableCellType.EDITABLE_TEXT_WITH_ICON,
  },
  {
    key: BUCKET_FIELD_KEYS.sub_bucket,
    label: "Sub-Bucket",
    order: 1,
    width: 14,
    sortable: true,
    type: TableCellType.EDITABLE_TEXT_WITH_ICON,
  },
  {
    key: BUCKET_FIELD_KEYS.keywords,
    label: "Key words",
    order: 2,
    width: 68,
    sortable: false,
    type: TableCellType.EDITABLE_TAG_LIST,
  },
];

export interface BucketTableRow {
  id: string;
  isDirty: boolean;
  [BUCKET_FIELD_KEYS.name]: EditableTextWithIconCellValue;
  [BUCKET_FIELD_KEYS.sub_bucket]: EditableTextWithIconCellValue;
  [BUCKET_FIELD_KEYS.keywords]: EditableTagListCellValue;
}

export const buildBucketTableRows = (
  rows: BucketRow[],
  isDirty: (id: string) => boolean,
): BucketTableRow[] =>
  rows.map((row) => ({
    id: row.id,
    isDirty: isDirty(row.id),
    [BUCKET_FIELD_KEYS.name]: {
      value: row.name,
      placeholder: "Bucket name",
      emptyLabel: "Untitled",
    },
    [BUCKET_FIELD_KEYS.sub_bucket]: {
      value: row.sub_bucket,
      placeholder: "Sub-bucket",
      emptyLabel: "—",
    },
    [BUCKET_FIELD_KEYS.keywords]: {
      values: row.keywords,
      placeholder: "Add keyword",
      maxVisibleTags: 3,
    },
  }));
